import { adminApi, devlopConfigAPi } from "src/api";
const deleteCaseTemplate = (id) => {
    return adminApiForSuisseBase.delete(`Customer/DeleteTemplate/${id}`)
 }
 const getFileURL = (customerId) => {
    return adminApi.get(`CaseManagement/FilePreview/${customerId}`);
};
const getDocumentReplies = (id) => {
    return adminApi.get(`Case/Accounts/${id}/Messages`)
}
const getCasesTemplate = (id) => {
    return adminApiForSuisseBase.get(
        ApiControllers.customers + `CasesTemplate/${id}`
    );
};
const approveDoc = (obj) => {
    return devlopConfigAPi.post(`CaseManagement/Admin/Accounts`, obj);
}
const apis = {
    deleteCaseTemplate, getCasesTemplate, getFileURL, getDocumentReplies, approveDoc
}
export default apis